import { CopilotDocument } from './document';
import type { EncounterStatus } from './encounter-status';

export interface DocumentsData {
  original: CopilotDocument[];
  processed: CopilotDocument[];
}

export interface Note {
  duration: number;
  note: string;
}

export interface DictationMetrics {
  totalOriginal: number;
  totalProcessed: number;
}

export interface RawTranscriptionWord {
  start?: number;
  end?: number;
  word: string;
  speakerTag?: number;
  confidence?: number;
}

export interface RawTranscription {
  words?: RawTranscriptionWord[];
}

export enum SessionType {
  Encounter = 'encounter',
  Upload = 'upload',
  Dictation = 'dictation',
}

export interface DictationCopilotMeta {
  status: EncounterStatus;
  type?: SessionType;
  documents: DocumentsData;
  subject_name: string;
  subject_prefix?: string;
  subject_first_name?: string;
  subject_middle_name?: string;
  subject_last_name?: string;
  subject_sex?: string | null;
  subject_death_indicator?: string | null;
  subject_id: string;
  subject_visit_id: string;
  subject_alternative_id: string;
  subject_dob: string;
  facility_id?: number | null;
  /** HL7 visit primary key, or null when the encounter was started without a visit. */
  visit_id?: number | null;
  /** Schedule task primary key, or null when the encounter was not started from the schedule. */
  order_id?: number | null;
  /** Snapshot of the selected visit's location so it can be shown without re-fetching. */
  visit_location?: string | null;
  visit_hospital_service?: string | null;
  visit_clinic_type_code?: string | null;
  visit_admit_date_time?: string | null;
  visit_discharge_date_time?: string | null;
  visit_consultant_doctor?: string | null;
  visit_consultant_doctor_prefix?: string | null;
  visit_consultant_doctor_first_name?: string | null;
  visit_consultant_doctor_last_name?: string | null;
  visit_referring_doctor?: string | null;
  visit_referring_doctor_prefix?: string | null;
  visit_referring_doctor_first_name?: string | null;
  visit_referring_doctor_last_name?: string | null;
  metrics: DictationMetrics;
  transcription?: string;
  /** Latest persisted document generation source content change (transcription or notes). */
  content_updated_at?: string;
  notes?: Note[];
  upload_filename?: string;
  uploaded_at?: string;
}

export interface Dictation {
  _id: string;
  audio: string;
  priority: number;
  type: string;
  status: string;
  sampleRate: number;
  author: string;
  engine: string;
  language: string;
  topic: string;
  application: string;
  version: string;
  createdAt: string;
  copilot?: DictationCopilotMeta;
  rawTranscription?: RawTranscription;
  duration: number;
  audioDeletedAt?: string | null;
  transcriptionDeletedAt?: string | null;
}

export interface CreateDictationPayload {
  application: string;
  author: string;
  engine: string;
  language: string;
  topic: string;
  type: string;
  version: string;
}
